import { render, staticRenderFns } from "./Superlatives.vue?vue&type=template&id=31b5856b&scoped=true"
import script from "./Superlatives.vue?vue&type=script&lang=js"
export * from "./Superlatives.vue?vue&type=script&lang=js"
import style0 from "./Superlatives.vue?vue&type=style&index=0&id=31b5856b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5856b",
  null
  
)

export default component.exports